// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"c625eb5e","166":"e894527c","175":"d876e621","283":"959b0592","504":"db412257","662":"4a6300db","898":"41517521","910":"5b860dfd"}[chunkId] + ".chunk.js";
};